import { Box, Dialog, DialogActions } from "@mui/material";
import React from "react";
import Button from "./Button";
import CloseBtn from "./CloseBtn";
import Heading from "./Heading";

export const WarningDialog = ({
  text,
  dialogOpen,
  setDialogOpen,
  handleConfirm,
}: {
  text: string;
  dialogOpen: boolean;
  setDialogOpen: (s: boolean) => void;
  handleConfirm: () => void;
}) => {
  return (
    <Dialog
      open={dialogOpen}
      maxWidth="md"
      fullWidth
      onClose={() => setDialogOpen(false)}
    >
      <Box
        sx={{
          padding: "26px 0px 0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <CloseBtn onClose={() => setDialogOpen(false)} />

        <Box sx={{ textAlign: "center", color: "warning.main" }}>
          <span
            className="material-symbols-outlined"
            style={{ fontSize: "60px" }}
          >
            warning
          </span>
        </Box>
        <Heading text={text} type="h5" isBold />

        <DialogActions
          sx={{
            m: "20px 0px 22px 0px",
            display: "flex",
            justifyContent: "center",
            columnGap: "20px",
            alignItems: "center",
          }}
        >
          <React.Fragment>
            <Button
              text="Cancel"
              fullWidth={false}
              variant="outlined"
              type="button"
              onClick={() => setDialogOpen(false)}
            />
            <Button
              text="Confirm"
              fullWidth={false}
              className="ml-1"
              onClick={handleConfirm}
            />
          </React.Fragment>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
